export default {
  title: 'Novo preço',
  fields: {
    product: {
      label: 'Produto',
    },
    is_not_personal: {
      label: 'Visível para todos',
    },
    is_default: {
      label: 'Predefinição',
    },
    visible_to: {
      label: 'Visível para',
    },
  },
  buttons: {
    select_all: 'Selecionar tudo',
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  feedback: {
    missing_info: 'Informação em falta',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    price_got_created: 'Preço criado',
    price_got_updated: 'Preço atualizado',
  },
};
